module.exports = __webpack_public_path__ + "sunsemweb/img/hbanner.e534a618.png";